import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { csvFileSelect } from '../../actions/'

import Button from '@material-ui/core/Button'

import DescriptionIcon from '@material-ui/icons/Description'
import BrowserStore from 'store'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

class UploadForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isRoleSelected: [],
      items: [],
      value: '',
      error: null,
      inseadCanvasAdmin: BrowserStore.get('inseadCanvasAdmin')
    }
  }

  render() {
    const { progress, onFileSelect } = this.props

    const upload = (e) => {
      const [file] = e.target.files || e.dataTransfer.files

      onFileSelect(file)
    }

    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <div>
            <form>
              <input
                style={{ display: 'none' }}
                id='csv_file_input'
                className='button'
                type='file'
                onChange={upload}
              />

              <label
                className='MuiButtonBase-root MuiButton-root MuiButton-contained makeStyles-button-27 MuiButton-containedPrimary'
                htmlFor='csv_file_input'
              >
                Select Csv File <DescriptionIcon />{' '}
              </label>
            </form>
          </div>
        </Grid>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.rootReducer
})
const mapDispatchToProps = (dispatch) => ({
  onFileSelect: (file) => {
    dispatch(csvFileSelect(file))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadForm)
